import * as actions from './actions'
import mutations from './mutations'
import * as getters from './getters'

const ServiceStore = {
  state: {
    services: [],
    service: {}
  },
  getters,
  mutations,
  actions
}

export default ServiceStore